<template>
    <div id='network' v-show="$route.query.debug">
        <div class='username'>
            {{ user ? user.get('username') : 'anonymous' }}@{{ device ? device.get('data').id : 'undefined'}}
        </div>
        <div>
        <sync v-if="wsStatus == 'opened'" class='wsStatus mdi mdi-36px'/>
        <sync-off v-if="wsStatus !== 'opened'" class='wsStatus'/>
        </div>
        <detect-network v-on:detected-condition='detected'>
            <div slot='online' class='netStatus'><lan-connect/></div>
            <div slot='offline' class='netStatus'><lan-disconnect/></div>
        </detect-network>
        <div>
        <download-network class='cacheStatus' v-if='readCache === false'/>
        <close-network class='cacheStatus' v-if='readCache === true'/>
        </div>
    </div>
</template>

<script>
import detectNetwork from 'v-offline'
import LanConnect from 'vue-material-design-icons/lan-connect.vue'
import LanDisconnect from 'vue-material-design-icons/lan-disconnect.vue'
import Sync from 'vue-material-design-icons/sync.vue'
import SyncOff from 'vue-material-design-icons/sync-off.vue'
import DownloadNetwork from 'vue-material-design-icons/download-network.vue'
import CloseNetwork from 'vue-material-design-icons/close-network.vue'

export default {
  name: 'network',
  components: {
    detectNetwork,
    LanConnect,
    LanDisconnect,
    Sync,
    SyncOff,
    DownloadNetwork,
    CloseNetwork
  },
  computed: {
    device: function () {
      return this.$store.getters.device
    },
    user: function () {
      return this.$store.getters.user
    },
    readCache () {
      return this.$store.state.readCache
    },
    connected () {
      return this.$store.state.connected
    },
    wsStatus () {
      return this.$store.state.wsStatus
    }
  },
  data () {
    return {
      username: ''
    }
  },
  methods: {
    detected (e) {
      this.$store.commit('setConnected', e)
      console.log("CONNECTED detected", e);
    }
  },
  mounted: function () {
    this.$vueParse.Parse.LiveQuery.on('open', () => {
      console.log('socket connection established')
      this.$store.commit('setConnected', true)
      this.$store.commit('setWsStatus', "opened")
      console.log("CONNECTED wsOpen", true);
    })
    this.$vueParse.Parse.LiveQuery.on('close', () => {
      console.log('socket connection closed')
      this.$store.commit('setWsStatus', "closed")
      this.$store.commit('setConnected', false)
      console.log("CONNECTED wsClose", false);
    })
    this.$vueParse.Parse.LiveQuery.on('error', (error) => {
      console.log('socket connection error', error)
      this.$store.commit('setWsStatus', "error")
      this.$store.commit('setConnected', false)
      console.log("CONNECTED wsError", false);
    })
  }
}
</script>

<style lang="scss" scoped>
#network {
  top: 0px;
  position: fixed;
  right: 0px;
  font-size: 1.2rem;
}

.username {
  position: absolute;
  right: 100px;
}

.netStatus {
  position: absolute;
  right: 72px;
}

.wsStatus {
  right: 24px;
}

.cacheStatus {
  right: 0px;
}

.material-design-icon {
  position: absolute;
  fill: dark;
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/tools/network/network.vue